<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="form-group">
                    <label>Vehicle</label>
                    <div class="text-danger" v-if="deliveryResequence.vehicleId.hasError">
                        {{deliveryResequence.vehicleId.errorMessage}}
                    </div>
                    <bootstrap-select :selectOptions="vehicles" :selectedOption="deliveryResequence.vehicleId.value" :elementId="'vehicleSelect'"
                                      :returnSelectedOptionText="true"
                                      @changeSelect="onVehicleSelect"></bootstrap-select>
                </div>
                <div class="form-group">
                    <label>Expected Date of Delivery</label>
                    <div class="text-danger" v-if="deliveryResequence.expectedDateOfDelivery.hasError">
                        {{deliveryResequence.expectedDateOfDelivery.errorMessage}}
                    </div>
                    <date-picker :format="'DD/MM/YYYY'" :elementId="'expectedDateOfDeliverySelect'" :date="deliveryResequence.expectedDateOfDelivery.value"
                                 @dateChange="onExpectedDateOfDeliverySelect"></date-picker>
                </div>

                <div id="accordion" class="mb-3">
                    <div class="card mb-1" v-for="(deliveryBatch, index) in deliveryBatches">
                        <div class="card-header" :id="'heading' + index">
                            <h5 class="m-0">
                                <a class="btn btn-link text-dark collapsed w-100 text-left" data-toggle="collapse" :href="'#collapse' + index" aria-expanded="false">
                                    {{deliveryBatch.sbo}}
                                </a>
                            </h5>
                        </div>

                        <div :id="'collapse' + index" class="collapse" :aria-labelledby="'heading' + index" data-parent="#accordion" style="">
                            <div class="card-body">
                                <div class="text-danger" v-if="deliveryBatch.hasError">
                                    {{deliveryBatch.errorMessage}}
                                </div>
                                <div class="table-responsive pt-4">
                                    <table class="table table-hover mb-0">
                                        <thead>
                                        <tr>
                                            <th>Order #</th>
                                            <th>Customer</th>
                                            <th>Order Date</th>
                                            <th>Expected Date Of Delivery</th>
                                            <th>Ship Number</th>
                                            <th>Driver</th>
                                            <th>Customer Purchase Order Number</th>
                                            <th>SBO</th>
                                            <th>Total</th>
                                            <th>Status</th>
                                            <th>Sequence</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(order, index) in deliveryBatch.deliveryOrderAndSequences" :key="index">
                                            <td>{{ order.orderId }}</td>
                                            <td>{{ order.registeredCompanyName }}</td>
                                            <td>{{ order.dateOrderPlaced }}</td>
                                            <td>{{ order.expectedDeliveryDate }}</td>
                                            <td>{{ order.fleetNumber }}</td>
                                            <td>{{ order.driver }}</td>
                                            <td>{{ order.customerPurchaseOrder }}</td>
                                            <td>{{ order.sbo }}</td>
                                            <td>{{ order.totalAsString }}</td>
                                            <td>{{ order.description }}</td>
                                            <td>
                                                <input type="number" v-model="order.sequenceNo" @blur="onSequenceInput(order, deliveryBatch)"/>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button class="btn btn-primary mr-2" @click="onBackClick" :disabled="loading" 
                        v-if="deliveryResequence.expectedDateOfDelivery.value !== null && deliveryResequence.vehicleId.value">
                    Back
                </button>
                <button class="btn btn-primary" @click="onResequenceOrdersButtonClick" :disabled="loading"
                        v-if="deliveryResequence.expectedDateOfDelivery.value !== null && deliveryResequence.vehicleId.value">
                    Resequence Orders
                </button>
            </div>
        </div>
    </div>
</div>
